import * as Scrivito from "scrivito";
import blogObjIcon from "assets/images/blog_obj.svg";
import SectionWidget from "widgets/SectionWidget/SectionWidgetClass";
import {
  metadataConfiguratorInitialContent,
  metadataEditingConfigAttributes,
  metadataConfiguratorPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";

Scrivito.provideEditingConfig("LibraryCustom", {
  title: "Library Custom",
  thumbnail: blogObjIcon,
  attributes: {
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
  },
  properties: defaultPageProperties,
  propertiesGroups: [
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    title: "Library Custom",
    showConfiguratorNav: true,
    body: [new SectionWidget({})],
  },
  validations: [...defaultPageValidations, ...metadataValidations],
});
